import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from 'app/i18n';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  templateUrl: 'confirm-modal.component.html'
})
export class ConfirmModalComponent {
  @Output() response: EventEmitter<any> = new EventEmitter();
  @Input() title = '';
	@Input() message = '';
  @Input() subMessage = '';
  @Input() loading = false;

  constructor(
    private translate : TranslateService,
    private modalService : BsModalService,
    public bsModalRef: BsModalRef) 
  { }

  confirm() {
    this.response.emit(true);
  }

  closeModal() {
    this.response.emit(false);
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/directives/confirm-modal/confirm-modal.component.ts